import React, { useState } from "react";
import axios from "axios";
import Results from "./Results";
import Photos from "./Photos";
import './Dictionary.css';

export default function Dictionary(props) {
  let [keyword, setKeyword] = useState(props.defaultKeyword);
  let [results, setResults] = useState(null);
  let [loaded, setLoaded] = useState(false);
  let [photos, setPhotos] = useState(null);

function handleDictionaryResponse(response) {
  setResults(response.data[0]);
}

function handleResponse(response) {
  setPhotos(response.data.photos);
}

function search() {
  let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
  axios.get(apiUrl).then(handleDictionaryResponse);

  let sheCodesApiKey = "bd79ao40tde3dec118ca46bc3e6dd55f";
  let sheCodesApiUrl = `https://api.shecodes.io/images/v1/search?query=${keyword}&key=${sheCodesApiKey}`;
  axios.get(sheCodesApiUrl).then(handleResponse);
}

function handleSubmit(event) {
  event.preventDefault();
  search();
}

function handleKeywordChange(event) {
  setKeyword(event.target.value);
}

function load() {
  setLoaded(true);
  search();
}

if (loaded) {
  return (
    <div className="Dictionary">  
    <section> 
      <h1>What word do you want to look up?</h1>
     <form onSubmit={handleSubmit}>
        <input type="search" 
        onChange={handleKeywordChange} 
        defaultValue={props.defaultKeyword} 
        />
     </form>
     <div className="hint">
      Suggested words: sunset, wine, yoga, plant...
     </div>
     </section>  
     <Results results={results} />
     <Photos photos={photos} />
     </div>
    );
} else {
  load();
  return "Loading";
}
}
